import { Box, Button, Typography, Grid, Card, IconButton, Divider } from '@mui/material';
import { dateChanger } from '../../shared/extra';
import { actionNotifier } from '../tostify';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import React, { useState } from 'react';
import { ContentCopy, Visibility, VisibilityOff } from '@mui/icons-material';
import NoImage from "../../assets/no-image-placeholder.png";
import Barcode from "react-barcode";



function MultipleVouchers({ mobileVocher, ProductImage, ProductData, voucher,  SingleVoucher = true }) {
    const [showPin, setShowPin] = useState(false);
    const mobileImgae = mobileVocher?.ProductData?.item?.productDatum?.productImages?.[0]?.url
    const desktopImage = ProductImage?.productDatum?.productImages?.[0]?.url


    const handleCopy = (title, codeValue) => {
        if (title === "voucher-no") {
            actionNotifier.info("Voucher No. Copied!", {
                position: "top-right",
                autoClose: 600,
                theme: "dark",
                hideProgressBar: true
            });
        } else {
            actionNotifier.info("Voucher Pin Copied!", {
                position: "top-right",
                autoClose: 600,
                theme: "dark",
                hideProgressBar: true
            });
        }
        navigator?.clipboard?.writeText(codeValue);
    };

    const originalBorderStyle = {
        borderRight: { xs: 'none', sm: '1px solid #E5E7EB' },

    };

    return (
        <Card
            className="coupon"
            sx={{
                width: "100%",
                maxWidth: 700,

                mb: 1,
                p: 2,
                borderRadius: '12px',
                border: '1px solid #F3F4F6',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
                '&:hover': {
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.02)'
                },

            }}
        >
            <Grid container spacing={1} alignItems="center"

            >

                {/* 1. IMAGE/LOGO SECTION */}
                <Grid item xs={3} sm={1} md={0.8} order={{ xs: 1, sm: 1 }} sx={originalBorderStyle}>
                    <Box
                        sx={{
                            width: 50,
                            height: 50,
                            borderRadius: '10px',
                            backgroundColor: '#EEF2FF',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            component="img"
                            src={desktopImage || mobileImgae || NoImage}
                            loading="lazy"
                            alt={ProductData?.name}
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: 'cover',
                            }}
                        />
                    </Box>
                </Grid>

                {/* 2. VOUCHER CODE SECTION */}
                <Grid
                    item
                    xs={12}
                    sm={4}
                    md={3.7}
                    order={{ xs: 4, sm: 2 }}
                    sx={{
                        ...originalBorderStyle,
                        pl: { xs: '0px', sm: '42px !important' }
                    }}
                >
                    <MultipleVoucherDesignComponent
                        title="Voucher Code"
                        codeType="voucher-no"
                        Code={voucher?.code ?? "No Code Available"}
                        handleCopy={handleCopy}
                    />
                </Grid>

                {/* 3. VOUCHER PIN SECTION */}
                <Grid item xs={12} sm={3} md={2.5} order={{ xs: 5, sm: 3 }} sx={originalBorderStyle}>
                    <MultipleVoucherDesignComponent
                        title="PIN Code"
                        codeType="voucher-pin"
                        Code={voucher?.pin ?? "No PIN Available"}
                        handleCopy={handleCopy}
                        isPin={true}
                        showPin={showPin}
                        setShowPin={setShowPin}
                    />
                </Grid>

                {/* 4. AMOUNT & DESKTOP EXPIRY SECTION */}
                <Grid item xs={4} sm={2} md={2.5} order={{ xs: 2, sm: 4 }} sx={originalBorderStyle}>
                    <Typography variant="caption"
                        sx={{
                            color: '#4B5563',
                            fontWeight: 500,
                            display: 'block',
                            mb: { xs: 0, sm: 1.5 },
                            fontFamily: "Be Vietnam pro",
                            fontSize: { xs: "auto", sm: "10px" }
                        }}>
                        Denomination
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontFamily: "Be Vietnam Pro",
                            fontWeight: 600,
                            color: "#2563EB",
                        }}
                    >
                        {voucher?.amount}
                    </Typography>



                </Grid>

                {/* 5. TOP RIGHT SECTION (xs: Calendar + Active Chip | sm+: Status & Info) */}
                <Grid item xs={5} sm={2} md={2.5} order={{ xs: 3, sm: 4 }} sx={originalBorderStyle}>
                    {/* Desktop "Expired" tag */}
                    <Typography
                        variant="caption"
                        sx={{
                            color: "#6B7280",
                            display: { xs: "none", sm: "block" },
                            fontFamily: "Be Vietnam Pro",
                            fontSize: { xs: "9px", sm: "10px" },
                            mb: { xs: 0, sm: 1.5 },
                        }}
                    >
                        Expired
                    </Typography>
                    {/* Desktop Date layout */}
                    <Typography variant="caption"
                        sx={{
                            color: '#374151',
                            fontWeight: 600,
                            display: { xs: 'none', sm: 'block' },
                            noWrap: true,
                            fontFamily: "Be Vietnam Pro"
                        }}
                    >
                        {dateChanger(voucher?.expiresAt)}
                    </Typography>

                    {/* NEW: Mobile Only Top Right placement for Calendar + Active Chip */}
                    <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                color: "#6B7280",
                                display: { xs: "block", sm: "none" },
                                fontFamily: "Be Vietnam Pro",
                                fontSize: { xs: "9px", sm: "10px" },
                            }}
                        >
                            Expired
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', color: '#6B7280' }}>

                            <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '0.70rem' }}>
                                {dateChanger(voucher?.expiresAt)}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>

                {/* 6. MOBILE ONLY BOTTOM ROW (Now strictly handles "generated + date") */}
                <Grid
                    item
                    xs={12}
                    order={6}
                    sx={{
                        display: { xs: 'flex', sm: 'none' },
                        alignItems: 'center',
                        mt: 1
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography variant="caption" sx={{ color: '#6B7280', fontFamily: "Be Vietnam Pro", textTransform: 'lowercase' }}>
                            generated:
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#374151', fontWeight: 600, fontFamily: "Be Vietnam Pro" }}>
                            {dateChanger(voucher?.createdAt)}
                        </Typography>
                    </Box>
                </Grid>

            </Grid>
            <Divider
                sx={{
                    borderStyle: "dashed",
                    my: 2.5,
                    borderColor: "#4d5057",
                    borderWidth: "1px",
                }}
            />

            <Box
                sx={{
                    width: 340,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    m: "auto",
                    gap: 1,
                    "& svg": {
                        width: "100%",
                        height: "70px",
                    },
                }}
            >
                <Barcode
                    value={voucher?.code}
                    displayValue={false}
                    width={2.2}
                    height={70}
                    margin={0}

                />

                <Typography
                    sx={{
                        fontSize: "11px",
                        color: "#6B7280",
                        fontFamily: "Be Vietnam Pro",
                        textAlign: "center",
                        letterSpacing: "0.3px",
                        fontWeight: 500,
                    }}
                >
                    Scan to retrieve voucher details
                </Typography>
            </Box>

        </Card>
    );
}

function MultipleVoucherDesignComponent({
    title,
    codeType,
    Code,
    handleCopy,
    isPin = false,
    showPin = false,
    setShowPin
}) {

    const hasCode =
        Code !== null &&
        Code !== undefined &&
        String(Code).trim() !== "" &&
        Code !== "No Code Available" &&
        Code !== "No PIN Available";

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>

            <Typography
                variant="caption"
                sx={{
                    color: '#4B5563',
                    fontWeight: 600,
                    display: 'block',
                    mb: 0.5,
                    fontFamily: "Be Vietnam pro",
                    fontSize: "10px"
                }}
            >
                {title}
            </Typography>

            {/* IF CODE NOT AVAILABLE */}

            {!hasCode ? (

                <Typography
                    variant="body2"
                    sx={{
                        color: '#9CA3AF',
                        fontFamily: "Be Vietnam Pro",
                        fontSize: "0.85rem"
                    }}
                >
                    --
                </Typography>

            ) : (

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', sm: 'column' },
                        alignItems: { xs: 'center', sm: 'flex-start' },
                        justifyContent: { xs: 'space-between', sm: 'flex-start' },
                        gap: { sm: 1 },
                        mb: 0.5
                    }}
                >

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <Typography
                            variant="body1"
                            sx={{
                                fontWeight: 500,
                                color:
                                    isPin && !showPin
                                        ? '#111827'
                                        : '#1E3A8A',

                                letterSpacing:
                                    isPin && !showPin
                                        ? '3px'
                                        : '0.5px',

                                mr: 1,
                                fontSize:
                                    isPin && !showPin
                                        ? '1rem'
                                        : '0.85rem',

                                wordBreak: 'break-all',
                                fontFamily: "Be Vietnam Pro"
                            }}
                        >
                            {isPin
                                ? (showPin ? Code : '••••••')
                                : Code}
                        </Typography>

                        {isPin && (
                            <IconButton
                                size="small"
                                onClick={() => setShowPin(!showPin)}
                                sx={{ p: 0.5 }}
                            >
                                {showPin
                                    ? <VisibilityOff fontSize="small" />
                                    : <Visibility fontSize="small" />
                                }
                            </IconButton>
                        )}

                    </Box>

                    <CopyToClipboard
                        text={Code}
                        onCopy={() => handleCopy(codeType, Code)}
                    >
                        <Button
                            size="small"
                            startIcon={
                                <ContentCopy
                                    sx={{ fontSize: '14px !important' }}
                                />
                            }
                            sx={{
                                textTransform: 'none',
                                color: '#2563EB',
                                fontWeight: 600,
                                p: 0,
                                minWidth: 0,
                                fontFamily: "Be Vietnam Pro",
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            Copy {isPin ? 'PIN' : 'Code'}
                        </Button>
                    </CopyToClipboard>

                </Box>
            )}
        </Box>
    );
}
export default MultipleVouchers;